<% recoverable_errors.forEach(function(error) { %>
  <%= renderPartial('appointment_booking/wizard/templates/step/confirmation/callouts/edit_appointment/' + error, obj) %>
<% }) %>

<div class="visit-type-field-container"></div>
<div class="slot-field-container"></div>
